/*eslint-disable*/
import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { language } from "config";
import Material_React_Table from "../components/React_Material_Table/Material_React_Table_Nothing";
import { Box } from "@mui/material";
export default function DoctorEarning() {
  const columns = [
    { header: language.year, accessorKey: "year" },
    { header: language.months, accessorKey: "monthsName" },
    { header: language.doctor_name, accessorKey: "doctorName" },
    { header: language.vehicle_reg_no, accessorKey: "doctorVehicleNo" },
    { header: language.earning_amount, accessorKey: "doctorShare" },
  ];

  const [data, setData] = useState([]);
  const doctorearningdata = useSelector((state) => state.doctorearningdata);

  useEffect(() => {
    if (doctorearningdata.doctorearnings) {
      setData(doctorearningdata.doctorearnings);
    }
  }, [doctorearningdata.doctorearnings]);

  return doctorearningdata.loading ? (
    <CircularLoading />
  ) : (
    <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { id: false }, // This hides the "id" column initially
      }}
  
    />
  </Box>
  );
}
